import type { FC } from 'react';

import type { AssetsSegmentSchemaWithIdPatched } from '@iconik-io/iconik-api/src/schema_patched/assets_segments';
import { Button, Icon, type PressEvent, ToggleButton } from '@iconik-io/uad';

import { selectUserRoles } from '../../../../redux/auth/selectors';
import { useAppSelector } from '../../../../redux/redux_hooks';

import styles from './segment_controls.module.css';

type Props = {
  onReplyClick?: (event: PressEvent) => void;
  segment: AssetsSegmentSchemaWithIdPatched;
  replyButtonDisabled?: boolean;
  showReplies?: boolean;
  onShowRepliesThread?: () => void;
  numberOfReplies?: number;
  hasReplies?: boolean;
  isCurrentVersion?: boolean;
};

export const SegmentControls: FC<Props> = ({
  onReplyClick,
  segment,
  replyButtonDisabled,
  onShowRepliesThread,
  showReplies,
  numberOfReplies,
  hasReplies,
  isCurrentVersion,
}) => {
  const roles = useAppSelector(selectUserRoles);

  const isSegmentVersionMatchingPlayer =
    segment.version_id === undefined || isCurrentVersion;

  const canReply =
    onReplyClick &&
    isSegmentVersionMatchingPlayer &&
    roles.can_create_segments &&
    segment.status !== 'DELETED';

  const replyText =
    numberOfReplies === 1
      ? `${numberOfReplies} Reply`
      : `${numberOfReplies} Replies`;
  return (
    <div className={styles.segment_controls}>
      {canReply ? (
        <Button
          aria-label="Reply to comment"
          icon={<Icon name="reply" />}
          variant="tertiary"
          size="s"
          onPress={onReplyClick}
          isDisabled={replyButtonDisabled}
        />
      ) : null}
      {segment.top_level === true && hasReplies ? (
        <ToggleButton
          size="xs"
          variant="ghost"
          endIcon={
            <Icon
              name={
                showReplies
                  ? 'chevron_small_isolated_n'
                  : 'chevron_small_isolated_s'
              }
            />
          }
          onPress={onShowRepliesThread}
        >
          {replyText}
        </ToggleButton>
      ) : null}
    </div>
  );
};
